import React, { useRef } from "react";
import type { Chart } from "chart.js";

import { FundDetailsNav } from "../fund-details-nav/fund-details-nav";
import { FundsDetailsInfo } from "../fund-details-info/fund-details-info";

export const FundDetailsMain = () => {
  const ref = useRef<Chart<"pie", any, unknown> | undefined>(null);

  return (
    <div className="w-full h-full flex flex-col items-center gap-24px">
      <FundDetailsNav />
      <FundsDetailsInfo chartRef={ref} />
    </div>
  );
};
